import type { BoardCard, SearchResult } from "./card";

export type DependencyTeamFilter = "all" | "blocked" | "enabling" | "mutual";

export interface DependencyTeamItem {
  id: DependencyTeamFilter;
  name: string;
  description?: string;
}

export function isOrigin(card: SearchResult) {
  return !card.groupId || card.groupId === card.id;
}

export type CardSearchResult = SearchResult & { card: BoardCard };

// can be a ResolvedCard or a CardSearchResult
export interface SearchResultKey {
  id: string;
  boardId?: string;
  teamId?: string;
}
